var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2151,
    height: 2095,
    viewBox: "0 0 2151 2095",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1075.36,
    cy: 1047.27,
    rx: 128.5,
    ry: 1011,
    transform: "rotate(30 1075.36 1047.27)",
    fill: "#2563EB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1355.52,
    cy: 1209.02,
    rx: 110,
    ry: 959,
    transform: "rotate(30 1355.52 1209.02)",
    fill: "#2563EB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 795.203,
    cy: 885.518,
    rx: 110,
    ry: 959,
    transform: "rotate(30 795.203 885.518)",
    fill: "#2563EB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1602.34,
    cy: 1351.52,
    rx: 90,
    ry: 806,
    transform: "rotate(30 1602.34 1351.52)",
    fill: "#2563EB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1812.78,
    cy: 1473.02,
    rx: 90,
    ry: 520,
    transform: "rotate(30 1812.78 1473.02)",
    fill: "#2563EB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.942,
    cy: 621.518,
    rx: 90,
    ry: 520,
    transform: "rotate(30 337.942 621.518)",
    fill: "#2563EB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 548.387,
    cy: 743.018,
    rx: 90,
    ry: 806,
    transform: "rotate(30 548.387 743.018)",
    fill: "#2563EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3345beb663885314ac8714067caab96a.svg";
export { ForwardRef as ReactComponent };